import { createAction } from '@reduxjs/toolkit';

import type { CaptionLine } from './types';

export const captionsActions = {
  rttRequested: createAction('[Captions] rtt requested'),
  rttStopped: createAction('[Captions] rtt stopped'),
  captionsFailed: createAction('[Captions] captions failed to start'),
  captionsShown: createAction<boolean>('[Captions] captions shown'),
  captionLineReceived: createAction<CaptionLine>('[Captions] caption line received'),
  cleared: createAction('[Captions] cleared'),
};
